
//  Para formatear numero de precios
export  function formatNumber(num) { 
    if (isNaN(num)) {
        throw new Error("El valor proporcionado no es un número válido.");
    }

    // Convertir el número a un string con decimales y separadores adecuados
    const parts = num.toFixed(2).split("."); // Asegura dos decimales
    const integerPart = parts[0];
    const decimalPart = parts[1];

    // Formatear la parte entera con puntos como separadores de miles
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    // Retornar el número formateado con coma para decimales
    return `${formattedInteger},${decimalPart}`;
}



export async function enviarDatos(data) {

     const apiUrl = process.env.REACT_APP_API_URL;

    // Fetch para enviar los datos al servidor

    try {
        const response = await fetch(apiUrl+"api_v1/insert.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        });

        if (response.ok) {
            const result = await response.json();
            console.log("Datos enviados correctamente:", result);
        } else {
            console.error("Error en el servidor:", response.statusText);
        }
    } catch (error) {
        console.error("Error en el envío:", error);
    }
}
